import {Button} from "react-bootstrap";
import API, {HandleError} from "../API";
import {User} from "../models/User";
import {useContext, useRef, useState} from "react";
import AppContext from "../AppContext";
import {useSnackbar} from "notistack";
import TopicFinished from "./TopicFinished";
import VideoJS from './VideoJS'
import './CategoryVideo.scss';
import {PiVideoCameraSlashDuotone} from "react-icons/pi";
import {useTranslation} from "react-i18next";

export default function CategoryVideo({ topic, currentCat, setCurrentCat, course, setCourse, paused, showQuiz, closeCategory }) {
    const app = useContext(AppContext)
    const { t, i18n } = useTranslation();
    const { enqueueSnackbar } = useSnackbar()
    const [videoPlayed, setVideoPlayed] = useState(false)
    const [videoError, setVideoError] = useState(-1)
    const [points, setPoints] = useState({
        submitted: false,
        earned: 0
    })
    const playerRef = useRef(null);

    const videoSrc = 'https://cdn.theorieflix.nl/vt/' + topic.video_id + '.mp4'

    const videoJsOptions = {
        autoplay: !points.submitted,
        controls: true,
        responsive: true,
        playsinline: true,
        fluid: true,
        poster: 'https://cdn.theorieflix.nl/videos/poster.jpg',
        sources: [{
            src: videoSrc,
            type: 'video/mp4'
        }]
    };

    const handlePlayerReady = (player) => {
        playerRef.current = player;

        // You can handle player events here, for example:
        player.on('waiting', () => {

        });

        player.on('error', () => {
            const err = player.error();
            setVideoError(err.code)
            if(err.code >= 2)
                reportVideoError(err)
        })
        player.on('dispose', () => {

        });
        player.on('ended', () => {
            try {
                if(player.isFullscreen())
                    player.exitFullscreen()
            }
            catch(e) {

            }
            onVideoPlayed()
        });
        player.on('pause', () => {

        });
        //
        // if(!points.submitted) {
        //     setTimeout(() => {
        //         player.play()
        //     }, 1000)
        // }
    };
    const submitVideoPlayed = async() => {
        app.startLoading()
        try {
            const res = await API({
                method: 'POST',
                url: '/points',
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                },
                data: {
                    event: 'video_watched',
                    ref_id: course.topic.ID,
                    parent_id: app.user?.current_course
                }
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            setPoints({
                submitted: true,
                earned: res.data.points
            })
            app.stopLoading()
            app.setUser(new User(res.data.me));
            setCourse({...course, videoPlaying: false })
        }
        catch(e) {
            setCourse({...course, videoPlaying: false })
            setPoints({
                submitted: true,
                earned: 0
            })
            app.stopLoading()
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    const reportVideoError = async (err) => {
        app.startLoading()
        try {
            const res = await API({
                method: 'POST',
                url: '/error/videojs',
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                },
                data: {
                    topic_id: topic.ID,
                    video_id: topic.video_id,
                    src: videoSrc,
                    err: err.code
                }
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;
        }
        catch(e) {
            app.stopLoading()
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }
    const onVideoPlayed = async () => {
        setVideoPlayed(true)
        await submitVideoPlayed()
    }
    const goNext = () => {
        if(topic.questions.length > 0)
            showQuiz()
        else
            closeCategory()
    }

    return <div className={'category-video-wrapper ' + (!course.videoPlaying && points.submitted ? 'finished' : '')}>
        <TopicFinished perfect={false} title={t('finished.videoTitle')}
                       message={<div className="text-muted mb-4 small">
                           {t('finished.videoText')}
                       </div>} points={points.earned} goNext={goNext} buttonText={t('button.continue')} />

        {videoError < 0 && <div className="category-video">
            <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
            {/*<Vimeo video={topic.video_id} autoplay={true} onEnd={onVideoPlayed} onPlay={onVideoStarted} paused={paused} />*/}
        </div>}
        {videoError >= 0 && <div className="category-video-error">
            <h1 className="mb-4 title"><PiVideoCameraSlashDuotone size="38" className="me-3" /> {t('videoError.title')}</h1>
            <p>
                <p className="video-error-details">
                    Error Code: {videoError} &nbsp; &nbsp; | &nbsp; &nbsp; App Version: {process.env.REACT_APP_VERSION}
                </p>
                {t('videoError.text1')}
                <br />
                {t('videoError.text2')}
                <br />
                <br />
                <strong>
                    {t('videoError.text3')}
                    <br />
                    <br />
                    {t('videoError.text4')}
                </strong>
            </p>
        </div>}
        <div className="category-video-buttons pt-4 text-center">
            {course.videoPlaying && !currentCat.video_watched && !videoError && <div className="mt-4 mb-4 text-muted">{t('quiz.videoText')}</div>}
            {(videoPlayed || videoError >= 0) && topic.questions.length > 0 && <Button onClick={showQuiz} variant="success">{t('button.continue')}</Button>}
            {videoError >= 0 && topic.questions.length <= 0 && <Button onClick={onVideoPlayed} variant="success">{t('button.continue')}</Button>}
        </div>
    </div>
}